// types
import { Utilization, UtilizationCurrency } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Chip, ChipProps, Tooltip } from '@mui/material';

// utils
import { formatPercentage } from '../../../utils/format';

// props
export interface ChipCoverageProps {
	currency?: UtilizationCurrency;
	utilization?: Utilization;
}

export const ChipCoverage = ({ currency, utilization }: ChipCoverageProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	let color: ChipProps['color'] = 'default';
	let title;
	let value = 0;

	if (currency) {
		if (typeof currency.coverage === 'number') {
			value = currency.coverage;
		}

		const allTransactions = [...currency.in.transactions, ...currency.out.transactions];
		const includedTransactions = allTransactions.filter((transaction) => transaction.isIncluded);

		title = t('xOfYtransactions', {
			included: includedTransactions.length,
			total: allTransactions.length,
		});
	} else if (utilization) {
		if (typeof utilization.coverage === 'number') {
			value = utilization.coverage;
		}

		title = t('xOfYtransactions', {
			included: utilization.in.included.length + utilization.out.included.length,
			total:
				utilization.in.included.length +
				utilization.in.excluded.length +
				utilization.out.included.length +
				utilization.out.excluded.length,
		});
	}

	if (value > 0) {
		if (value >= 80) {
			color = 'success';
		} else if (value >= 60) {
			color = 'info';
		} else if (value >= 50) {
			color = 'warning';
		} else {
			color = 'error';
		}
	}

	const chip = (
		<Chip color={color} label={formatPercentage(value)} size="small" variant="twoTone" />
	);

	if (title) {
		return (
			<Tooltip arrow={true} placement="top" title={title}>
				{chip}
			</Tooltip>
		);
	}

	return chip;
};
